export default "__VITE_ASSET__BN94aOKR__"